window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.btn[data-to-load]').length) {
    import('./_loadmore.js').then((module) => {
      module.Init();
    });
  }
});

export default {};
